import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/documentation/network-connectivity-requirements',
)({
  beforeLoad: () => {
    throw redirect({ to: '/network-connectivity-requirements' });
  },
});
